var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal overflow-auto" }, [
    _c(
      "div",
      { staticClass: "card inner" },
      [
        _c("div", { staticClass: "header" }, [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_c("i", { staticClass: "icn icn-x sm" })]
          )
        ]),
        _c("div", { staticClass: "content" }, [
          _c(
            "form",
            {
              attrs: { id: "user-security" },
              on: {
                submit: [
                  function($event) {
                    $event.preventDefault()
                  },
                  _vm.edit
                ]
              }
            },
            [
              _c("h3", { staticClass: "sub-title" }, [_vm._v("Access")]),
              _c("div", { staticClass: "row mt-2" }, [
                _c(
                  "div",
                  { staticClass: "field" },
                  [
                    _c("Toggle", {
                      ref: "toggleEnable",
                      attrs: {
                        label: "Account Enabled",
                        default: _vm.item.isEnabled
                      }
                    })
                  ],
                  1
                ),
                _vm.canEditSuperAdmin
                  ? _c(
                      "div",
                      { staticClass: "field" },
                      [
                        _c("Toggle", {
                          ref: "toggleAdmin",
                          attrs: {
                            label: "Is super admin",
                            default: _vm.item.isSuperAdmin
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("h3", { staticClass: "sub-title" }, [_vm._v("Password")]),
              _c("div", { staticClass: "row mt-2" }, [
                _c("div", { staticClass: "field" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editItem.password,
                        expression: "editItem.password"
                      }
                    ],
                    attrs: {
                      type: "text",
                      placeholder: "New Password",
                      maxlength: "127",
                      minlength: "6",
                      autocomplete: "nope"
                    },
                    domProps: { value: _vm.editItem.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.editItem, "password", $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]
          )
        ]),
        _vm.errorMessage
          ? _c("Alert", { attrs: { message: _vm.errorMessage } })
          : _vm._e(),
        _vm.couldEditSuperAdmin
          ? _c("Alert", { attrs: { message: _vm.infoMessage } })
          : _vm._e(),
        _c("div", { staticClass: "footer" }, [
          _c(
            "button",
            {
              staticClass: "secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v("Cancel")]
          ),
          _c("div", { staticClass: "flex-grow" }),
          _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.edit()
                }
              }
            },
            [
              !_vm.isValidating ? _c("span", [_vm._v("Save")]) : _vm._e(),
              _vm.isValidating
                ? _c("span", { staticClass: "icon" }, [
                    _c("i", {
                      staticClass: "icn icn-refresh sm animate-reverse-spin"
                    })
                  ])
                : _vm._e()
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h2", [_vm._v("Edit Security Details")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }